import React from 'react';
import { observer } from 'mobx-react-lite';
import { MenuButtonWrapper, SideContainer, SideMenuContainer } from './SideMenu.style';
import { MenuSectionsLinksContainer, MenuSectionsTitle } from './MenuSections.style';
import { MenuItemsType } from './SideMenu';
import { useAppStateContext } from 'src/AppState/AppState';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';

interface SectionsLinksType {
    headerName: string;
    links: Array<MenuItemsType>;
}

// MOCKED LINKS
const sectionsLinks = (routerBackoffice: RouterBackoffice): Array<SectionsLinksType> => {
    const menuItems = [
        {
            headerName: 'Marketing',
            links: [
                {
                    id: 'promo-carousel',
                    label: 'Promo Carousel',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'promo-code',
                    label: 'Promo Code',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'promo',
                    label: 'Promo',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'landing-page',
                    label: 'Landing Page',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'live-notifications',
                    label: 'Live Notifications',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'welcome-bonus',
                    label: 'Welcome Bonus',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'globalV2',
                    label: 'Global',
                    onClick: (): void => routerBackoffice.redirectToCmsGlobalV2(),
                    isDisabled: false,
                },
                {
                    id: 'casino-banners',
                    label: 'Casino Banners',
                    onClick: (): void => {},
                    isDisabled: true,
                },
            ],
        },
        {
            headerName: 'Sportsbook',
            links: [
                {
                    id: 'promoted-events',
                    label: 'Promoted Events',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'hero-widgets',
                    label: 'Hero Widgets',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'hero-event-page',
                    label: 'Hero Event Page',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'special-sport',
                    label: 'Special Sport',
                    onClick: (): void => {},
                    isDisabled: true,
                },
            ],
        },
        {
            headerName: 'Site Management',
            links: [
                {
                    id: 'pagesV2',
                    label: 'Pages',
                    onClick: (): void => routerBackoffice.redirectToCmsPagesV2(),
                    isDisabled: false,
                },
                {
                    id: 'quick-link-tray',
                    label: 'Quick Link Tray',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'footer-settings',
                    label: 'Footer Settings',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'translations',
                    label: 'Translations',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'header-link-panel',
                    label: 'Header Link Panel',
                    onClick: (): void => {},
                    isDisabled: true,
                },
                {
                    id: 'seo',
                    label: 'SEO',
                    onClick: (): void => {},
                    isDisabled: true,
                },
            ],
        },
    ];

    return menuItems;
};

export const SubSectionsMenu = observer((): JSX.Element => {
    const { routerBackoffice } = useAppStateContext();

    const paramObj = routerBackoffice.getParametersAllFromNamespace('global');
    const paramKeys = Object.keys(paramObj);
    const paramKey = paramKeys[0];
    const param = routerBackoffice.getParametersString('global', paramKey ?? '');

    const menuItemsForView = sectionsLinks(routerBackoffice);

    return (
        <SideMenuContainer data-test='side-menu-root'>
            <SideContainer>
                {menuItemsForView.map((linkItem) => (
                    <div key={linkItem.headerName}>
                        <MenuSectionsTitle className='text-[0.714] font-semibold leading-[1.14]'>
                            {linkItem.headerName}
                        </MenuSectionsTitle>

                        <MenuSectionsLinksContainer>
                            {linkItem.links.map((item) => (
                                <MenuButtonWrapper
                                    key={item.label}
                                    isActive={param === item.id}
                                    onClick={item.onClick}
                                    isDisabled={item.isDisabled}
                                >
                                    {item.label}
                                </MenuButtonWrapper>
                            ))}
                        </MenuSectionsLinksContainer>
                    </div>
                ))}
            </SideContainer>
        </SideMenuContainer>
    );
});
